import React from 'react'
import UploadTabs from './UploadTabs'

const UploadArtWork = () => {
  return (
    <UploadTabs />
  )
}

export default UploadArtWork